import { useEffect } from "react";
import { SITE } from "@/lib/config";

const abs = (path) => `${SITE.url}${path}`;

export const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Mika Solution",
  url: SITE.url,
  logo: abs("/images/logo-mika.png"),
  email: SITE.email,
  telephone: SITE.phone,
  address: { "@type": "PostalAddress", streetAddress: "Jl. Raya Parung No.47, Ruko The Boulevard Blok A1, Jabon Mekar", addressLocality: "Parung, Kabupaten Bogor", addressRegion: "Jawa Barat", addressCountry: "ID" },
  description: "Layanan konsultasi dan pendampingan penyelesaian kewajiban pinjaman online, kartu kredit, dan KTA.",
  parentOrganization: { "@type": "Organization", name: SITE.parent.name, url: SITE.parent.url },
  sameAs: [SITE.instagramUrl],
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.label, item: abs(it.to) })),
});

export const Seo = ({ title, description, path = "/", type = "website", schema = [] }) => {
  useEffect(() => {
    document.querySelectorAll("[data-static-seo]").forEach((el) => el.remove());
  }, []);
  return (
  <>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={abs(path)} />
    <meta property="og:type" content={type} />
    <meta property="og:site_name" content="Mika Solution" />
    <meta property="og:locale" content="id_ID" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={abs(path)} />
    <meta property="og:image" content={abs("/images/og-image.jpg")} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={abs("/images/og-image.jpg")} />
    {schema.map((s, i) => (
      <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(s) }} />
    ))}
  </>
  );
};
